import type { Channel, ChannelType, ChannelStatus } from '@conversia/shared-types';
import { api } from './client';

/** Endpoints de canales. Prefijo: /api/channels */

export interface CreateChannelInput {
  type: ChannelType;
  name: string;
  config?: Record<string, unknown>;
}

export interface ConnectResult {
  status: ChannelStatus;
  qr?: string;
}

export const listChannels = () => api.get<Channel[]>('/api/channels');

export const getChannel = (id: string) => api.get<Channel>(`/api/channels/${id}`);

export const getChannelStatus = (id: string) =>
  api.get<{ status: ChannelStatus }>(`/api/channels/${id}/status`);

export const createChannel = (input: CreateChannelInput) =>
  api.post<Channel>('/api/channels', input);

export const updateChannel = (
  id: string,
  input: { name?: string; config?: Record<string, unknown>; defaultAgentId?: string | null },
) => api.patch<Channel>(`/api/channels/${id}`, input);

export const connectChannel = (id: string) =>
  api.post<ConnectResult>(`/api/channels/${id}/connect`);

export const disconnectChannel = (id: string) =>
  api.post<{ success: boolean }>(`/api/channels/${id}/disconnect`);

export const deleteChannel = (id: string) =>
  api.del<{ success: boolean }>(`/api/channels/${id}`);
